/* eslint-disable @next/next/no-html-link-for-pages */
import { Box, Badge } from "@chakra-ui/react";
import { useState, useEffect } from "react";

import { authLogout } from "../provider/auth";
import { GetCookie } from "../provider/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Router, useRouter } from "next/router";

import {
  faGlobe,
  faBuilding,
  faCaretDown,
  faCheck,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

import FeedbackModal from "../components/board/voc";
import SearchHeader from "../components/search_test";
import { useUser } from "../context/UserContext";
import { useQuoteCnt } from "../context/QuoteContext";
import { useCartCnt } from "../context/CartContext";

const PART_NUMBERS = [
  "IPW60R070C6",
  "STM32G071G8U6",
  "ISL8012IRZ-T",
  "SN74LVC07ARGYR",
];

export default function Header(props) {
  const [cartBadge, setCartBadge] = useState("red");
  const [showBox, setShowBox] = useState(false);

  const currentUser = useUser();
  const [user, setUser] = useState(currentUser);
  const [sellerPage, setSellerPage] = useState(
    user?.is_seller === "not_approved" ? "판매자신청" : "판매자페이지"
  );
  const cartCnt = useCartCnt();
  const quoteCnt = useQuoteCnt();

  // 마우스 hover -> onMouseEnter & onMouseLeave 이벤트
  const [headerProfileVisible, setHeaderProfileVisible] = useState(false);
  const [headerLangVisible, setHeaderLangVisible] = useState(false);

  const { pathname, push } = useRouter();
  const router = useRouter();
  const asPath = router.asPath;

  const [isNavOpen, setIsNavOpen] = useState(false);
  const [mobileLangEvent, setMobileLangEvent] = useState(false);

  const toggleVOCModal = () => {
    setShowBox((prev) => !prev); // 클릭할 때마다 열고 닫기 토글
  };

  const handleLogout = () => {
    authLogout();
  };

  const transferLanguage = async () => {
    if (pathname === "/marketplace/market") {
      window.location.href = "/en";
    } else if (pathname === "/seller/event") {
      window.location.href = "/en/seller/event";
    } else if (asPath === "/board/home?status=terms") {
      window.location.href = "/en/board/home?status=Terms";
    } else if (asPath === "/board/home?status=privacy") {
      window.location.href = "/en/board/home?status=Privacy";
    } else if (asPath === "/mypage/home?path=order") {
      window.location.href = "/en/mypage/home?path=Orders";
    } else if (asPath === "/mypage/home?path=info") {
      window.location.href = "/en/mypage/home?path=My%20Account";
    } else if (asPath === "/mypage/home?path=address") {
      window.location.href = "/en/mypage/home?path=Address";
    } else if (pathname === "/marketplace/cart") {
      window.location.href = "/en/market/cart";
    } else if (pathname === "/auth/login") {
      window.location.href = `/en/auth/login`;
    } else if (pathname === "/auth/req_password") {
      window.location.href = `/en/auth/req_password`;
    } else if (pathname === "/auth/register") {
      window.location.href = `/en/auth/register`;
    } else if (pathname === "/estimate/quote_lists") {
      window.location.href = `/en/estimate/lists`;
    } else {
      window.location.href = "/en";
    }
  };

  const [part, setPart] = useState(null);

  // 네비 문닫기
  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const happenMobileLangEvent = async () => {
    setMobileLangEvent(!mobileLangEvent);
  };

  // ✅ 판매자 승인 여부 확인 함수
  const checkApproved = async () => {
    try {
      const approvedCondition =
        user?.is_seller !== undefined ? user.is_seller : undefined;
      if (approvedCondition === undefined) {
        alert("로그인 후 이용해주세요.");
        push("/auth/login");
      } else if (approvedCondition === "submitted") {
        alert("승인 대기중입니다.\n영업일 기준 1일내로 연락드리겠습니다.");
      } else if (approvedCondition === "not_approved") {
        push("/board/register");
      } else if (approvedCondition === "approved") {
        push("/seller/dashboard");
      }
    } catch (err) {
      console.error("판매자 승인 확인 실패:", err);
      alert("잠시 후 다시 시도해주세요.");
    }
  };

  useEffect(() => {
    const idx = Math.floor(Math.random() * PART_NUMBERS.length);
    setPart(PART_NUMBERS[idx]);
  }, []);
  return (
    <>
      <Box id="Header">
        <header>
          <Box className="pc">
            <Box className="header_tp">
              <Box>
                <ul className="header_tp_lft">
                  <li>
                    <a href="/intro">판다파츠 소개</a>
                  </li>
                  <li>
                    <a href="/board/home?status=faq">고객센터</a>
                  </li>
                  <li>
                    <a href="/board/board_view?no=78&type=notice">후불결제</a>
                  </li>
                  <li>
                    <a href="/board/home?status=event">이벤트</a>
                  </li>
                  {user?.is_seller !== undefined ? (
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          checkApproved();
                        }}
                      >
                        {sellerPage}
                      </a>{" "}
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
                <ul className="header_tp_rt">
                  {user?.is_seller !== undefined ? (
                    <li>
                      <a href="/board/home?status=qna">QnA</a>
                    </li>
                  ) : (
                    <li>
                      <a href="/auth/login?before=/board/home?status=qna">
                        QnA
                      </a>
                    </li>
                  )}
                  <li>
                    <a
                      href="http://pf.kakao.com/_uKLiT/chat"
                      target="_blank"
                      rel="noreferrer"
                    >
                      채팅상담
                    </a>
                  </li>
                  <li>
                    <a href="mailto:support@partsgo.co.kr">이메일 문의</a>
                  </li>
                  <li onClick={toggleVOCModal} style={{ cursor: "pointer" }}>
                    <div></div>
                    <a>고객제안 VOC</a>
                  </li>
                  <li
                    className="header_trans_lang"
                    onMouseEnter={() => setHeaderLangVisible(true)}
                    onMouseLeave={() => setHeaderLangVisible(false)}
                  >
                    <div>
                      <FontAwesomeIcon icon={faGlobe} />
                      KO
                    </div>
                    {headerLangVisible && (
                      <nav className="language_version">
                        <div
                          className="language_version_ko"
                          onClick={() => {
                            setHeaderLangVisible(false);
                          }}
                        >
                          <div>
                            {/* <b>KO</b> */}
                            {/* <em></em> */}
                            <span>한국어</span>
                            {/* <FontAwesomeIcon icon={faCheck} /> */}
                          </div>
                        </div>
                        <div
                          className="language_version_en"
                          onClick={transferLanguage}
                        >
                          <div>
                            {/* <b>EN</b> */}
                            {/* <em></em> */}
                            <span>English</span>
                            {/* <FontAwesomeIcon icon={faCheck} /> */}
                          </div>
                        </div>
                      </nav>
                    )}
                  </li>
                </ul>
              </Box>
            </Box>
            {/* <Box className="header_md">
              <Box>
                <Box>
                  <Box className="header_md_new">
                    <span>신규</span>
                  </Box>
                  <Box className="header_md_ex">
                    <p>
                      온다파츠 웹 기반 SaaS 솔루션, 지금 바로 경험해 보세요.
                    </p>
                  </Box>
                  <Box className="header_md_goto">
                    <a
                      href="https://www.ondaparts.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>자세히 보기</span>
                      <FontAwesomeIcon icon={faArrowRight} />
                    </a>
                  </Box>
                </Box>
              </Box>
            </Box> */}
            <Box className="header_btm">
              <Box>
                <Box className="header_logo">
                  <a href="/">
                    <img
                      src="/images/pandaparts_logo_new.png"
                      width="200px"
                      height="auto"
                    />
                  </a>
                  {/* <span></span> */}
                </Box>
                <Box className="header_centre">
                  <Box className="header_searching">
                    <SearchHeader />
                  </Box>
                  <Box className="header_menu">
                    <ul>
                      <li>
                        <a href="/menu">
                          <span>카테고리</span>
                        </a>
                        {/* <div></div> */}
                      </li>
                      <li>
                        <a href="/marketplace/market">
                          <span>마켓플레이스</span>
                        </a>
                        {/* <div></div> */}
                      </li>
                      <li>
                        <a href="/estimate/home">
                          <span>판다봇 견적</span>
                        </a>
                        {/* <div></div> */}
                      </li>
                    </ul>
                    <Box className="header_keyword_area">
                      <div>
                        <span className="keyword_intro_text">
                          판다파츠 검색을 경험해보세요:&nbsp;&nbsp;
                        </span>
                        <a
                          href={`/search/lists?keyword=${part}`}
                          className="part_link"
                        >
                          <span>{part}</span>
                        </a>
                      </div>
                    </Box>
                  </Box>
                  {/* <Box className="header_ranking">
                    <Box className="ranking_wrap">
                      <Box position="relative">
                        <AutoRankingSlide />
                      </Box>
                    </Box>
                  </Box> */}
                </Box>

                <Box className="header_mypage">
                  <ul>
                    <li>
                      <a href="/cart/view">
                        {/* <img src="/images/basket.png" /> */}
                        <Badge
                          colorScheme={cartBadge}
                          p="2"
                          borderRadius={20}
                          marginLeft={1}
                          className="header_btn_badge"
                        >
                          {cartCnt}
                        </Badge>
                        <i className="xi-cart-o"></i>

                        <span>장바구니</span>
                      </a>
                    </li>
                    <li>
                      <a href="/marketplace/cart">
                        <Badge
                          colorScheme={cartBadge}
                          p="2"
                          borderRadius={20}
                          marginLeft={1}
                          className="header_btn_badge"
                        >
                          {quoteCnt}
                        </Badge>
                        <i className="xi-basket"></i>

                        <span>견적바구니</span>
                      </a>
                    </li>
                    {user?.is_seller !== undefined ? (
                      <li>
                        <a href="/mypage/quoteList">
                          <i className="xi-paper"></i>

                          <span>견적내역</span>
                        </a>
                      </li>
                    ) : (
                      <li>
                        <a href="/auth/login?before=/mypage/quoteList">
                          <i className="xi-paper"></i>

                          <span>견적내역</span>
                        </a>
                      </li>
                    )}

                    {user?.is_seller !== undefined ? (
                      <li>
                        <a href="/mypage/home?path=main">
                          <i className="xi-user"></i>
                          <span>마이페이지</span>
                        </a>
                      </li>
                    ) : (
                      <li>
                        <a href="/mypage/ordernum">
                          <i className="xi-file-check"></i>
                          <span>주문확인</span>
                        </a>
                      </li>
                    )}
                    {user?.is_seller !== undefined ? (
                      <li>
                        <button onClick={handleLogout}>
                          <i className="xi-log-out"></i>
                          <span>로그아웃</span>
                        </button>
                      </li>
                    ) : (
                      <li>
                        <a href="/auth/login">
                          <i className="xi-log-in"></i>
                          <span>로그인</span>
                        </a>
                      </li>
                    )}
                  </ul>
                  <Box className="header_ad">
                    <p>5만원 이상 주문 시, 무료배송</p>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className="mobile">
            <Box className="mobile_tp">
              <Box className="mobile_gnb">
                <button alt="모바일용 메뉴" onClick={toggleNav}>
                  <i className="xi-bars"></i>
                </button>
              </Box>
              <Box className="mobile_logo">
                <a href="/">
                  <img
                    src="/images/pandaparts_logo_new.png"
                    alt="모바일 로고"
                  />
                </a>
              </Box>
              <Box className="mobile_lang_area" onClick={happenMobileLangEvent}>
                <nav>
                  <button>
                    <FontAwesomeIcon icon={faGlobe} />
                    <span>KO</span>
                  </button>
                  <div></div>
                </nav>
                {/* {headerLangVisible && ( */}
                {mobileLangEvent === true ? (
                  <div className="mobile_lang_nav">
                    <div>
                      <div className="mobile_lang_bx ko">
                        <b>KO</b>
                        <em></em>
                        <span>한국어</span>
                        <FontAwesomeIcon icon={faCheck} />
                      </div>
                    </div>
                    <div onClick={transferLanguage}>
                      <div className="mobile_lang_bx en">
                        <b>EN</b>
                        <em></em>
                        <span>English</span>
                        <FontAwesomeIcon icon={faCheck} />
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {/* )} */}
              </Box>
            </Box>
            <Box className="mobile_btm">
              <Box className="mobile_searching">
                <SearchHeader />
              </Box>
            </Box>
            <Box className="mobile_keyword_related">
              <div className="keyword_relate_bx">
                <span className="keyword_intro_text">
                  판다파츠 검색을 경험해보세요:&nbsp;&nbsp;
                </span>
                <a
                  href={`/search/lists?keyword=${part}`}
                  className="core_keyword"
                >
                  <span>{part}</span>
                </a>
              </div>
            </Box>
          </Box>
        </header>
      </Box>
      <Box className={isNavOpen ? "mobile_nav active" : "mobile_nav"}>
        <Box className="mobile_nav_base">
          <Box className="mobile_nav_header">
            <Box className="nav_home">
              <a href="/">
                <i className="xi-home-o"></i>
              </a>
            </Box>
            <Box className="nav_close" onClick={toggleNav}>
              <i className="xi-close-thin"></i>
            </Box>
          </Box>
          <Box className="mobile_nav_mypage">
            <ul>
              <li>
                <a href="/cart/view">
                  {/* <img src="/images/basket.png" /> */}
                  <Badge
                    colorScheme={cartBadge}
                    p="2"
                    borderRadius={20}
                    marginLeft={1}
                    className="header_btn_badge"
                  >
                    {cartCnt}
                  </Badge>
                  <i className="xi-cart-o"></i>

                  <span>장바구니</span>
                </a>
              </li>
              <li>
                <a href="/marketplace/cart">
                  <Badge
                    colorScheme={cartBadge}
                    p="2"
                    borderRadius={20}
                    marginLeft={1}
                    className="header_btn_badge"
                  >
                    {quoteCnt}
                  </Badge>
                  <i className="xi-basket"></i>

                  <span>견적바구니</span>
                </a>
              </li>
              {user?.is_seller !== undefined ? (
                <li>
                  <a href="/mypage/quoteList">
                    <i className="xi-paper"></i>

                    <span>견적내역</span>
                  </a>
                </li>
              ) : (
                <li>
                  <a href="/auth/login?before=/mypage/quoteList">
                    <i className="xi-paper"></i>

                    <span>견적내역</span>
                  </a>
                </li>
              )}

              {user?.is_seller !== undefined ? (
                <li>
                  <a href="/mypage/home?path=main">
                    <i className="xi-user"></i>
                    <span>마이페이지</span>
                  </a>
                </li>
              ) : (
                <li>
                  <a href="/mypage/ordernum">
                    <i className="xi-file-check"></i>
                    <span>주문확인</span>
                  </a>
                </li>
              )}
              {user?.is_seller !== undefined ? (
                <li>
                  <button onClick={handleLogout}>
                    <i className="xi-log-out"></i>
                    <span>로그아웃</span>
                  </button>
                </li>
              ) : (
                <li>
                  <a href="/auth/login">
                    <i className="xi-log-in"></i>
                    <span>로그인</span>
                  </a>
                </li>
              )}
            </ul>
          </Box>
          <Box className="mobile_nav_ad">5만원 이상 주문 시, 무료배송</Box>
          <Box className="mobile_nav_menu">
            <ul>
              <li>
                <a href="/menu">카테고리</a>
              </li>
              <li>
                <a href="/marketplace/market">마켓플레이스</a>
              </li>
              <li>
                <a href="/estimate/home">판다봇 견적</a>
              </li>
            </ul>
          </Box>

          <Box className="mobile_nav_sub_menu">
            <ul>
              <li>
                <a href="/intro">판다파츠 소개</a>
              </li>
              <li>
                <a href="/board/home?status=faq">고객센터</a>
              </li>
              <li>
                <a href="/board/board_view?no=78&type=notice">후불결제</a>
              </li>
              <li>
                <a href="/board/home?status=event">이벤트</a>
              </li>
              {user?.is_seller !== undefined ? (
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      checkApproved();
                    }}
                  >
                    {sellerPage}
                  </a>{" "}
                </li>
              ) : (
                ""
              )}

              {user?.is_seller !== undefined ? (
                <li>
                  <a href="/board/home?status=qna">QnA</a>
                </li>
              ) : (
                <li>
                  <a href="/auth/login?before=/board/home?status=qna">QnA</a>
                </li>
              )}
              <li>
                <a
                  href="http://pf.kakao.com/_uKLiT/chat"
                  target="_blank"
                  rel="noreferrer"
                >
                  채팅상담
                </a>
              </li>
              <li>
                <a href="mailto:support@partsgo.co.kr">이메일 문의</a>
              </li>
              <li onClick={toggleVOCModal} style={{ cursor: "pointer" }}>
                <div></div>
                <a>고객제안 VOC</a>
              </li>
            </ul>
          </Box>
        </Box>
        <Box className="mobile_nav_bg" onClick={toggleNav}></Box>
      </Box>
      <FeedbackModal showBox={showBox} closeModal={() => setShowBox(false)} />
    </>
  );
}
